import React from 'react'
import classNames from 'classnames'

export const FilterBtn = (props) => <button
    className={ classNames(
      'category-filters__btn'
      , `category-filters__btn--${props.taxonomy}`
      , { 'active': props.active }
    ) }
    onClick  = { props.onClick }
    type     = 'button'
  >
    { props.children }
</button>

export { FilterBtn as default }

// vi: et shiftwidth=2 tabstop=2 softtabstop=2



// WEBPACK FOOTER //
// ./js/website/react_components/FilterBtn.js